// French labels configuration for the vehicle fleet management system
export const FRENCH_LABELS = {
  // Navigation
  dashboard: 'Tableau de bord',
  vehicles: 'Véhicules',
  maintenance: 'Maintenance',
  parking: 'Parking',
  equipment: 'Équipement',
  communications: 'Communications',
  alerts: 'Alertes',
  reports: 'Rapports',
  settings: 'Paramètres',
  
  // Vehicle fields (matching client's current system)
  marque: 'Marque',
  modele: 'Modèle',
  registrationNumber: 'Numéro d\'immatriculation',
  year: 'Année',
  mileage: 'Kilométrage',
  dateAchat: 'Date d\'achat',
  dossierTechnique: 'Dossier technique',
  dossierTechnique1: 'Dossier technique 1',
  dossierTechnique2: 'Dossier technique 2',
  dossierTechnique3: 'Dossier technique 3',
  placeParking: 'Place de parking',
  status: 'Statut',
  equipe: 'Équipe',
  attachments: 'Pièces jointes',
  notes: 'Notes',
  dateDerniereIntervention: 'Date dernière intervention',
  dateRevision: 'Date révision',
  prochaineRevision: 'Prochaine révision',
  
  // Additional vehicle fields
  fuelType: 'Type de carburant',
  transmissionType: 'Type de transmission',
  color: 'Couleur',
  insuranceExpiry: 'Expiration assurance',
  registrationExpiry: 'Date de 1ère immatriculation',
  serviceInterval: 'Intervalle de service (km)',
  
  // Status options (French)
  statusReady: 'Prêt',
  statusUnderMaintenance: 'En maintenance',
  statusUpcomingMaintenance: 'Maintenance prochaine',
  statusMaintenanceNeeded: 'Maintenance requise',
  statusWashing: 'Lavage',
  statusOut: 'Sorti',
  statusReturned: 'Retourné',
  
  // Actions
  create: 'Créer',
  edit: 'Modifier',
  delete: 'Supprimer',
  save: 'Enregistrer',
  cancel: 'Annuler',
  view: 'Voir',
  export: 'Exporter',
  import: 'Importer',
  upload: 'Télécharger',
  download: 'Télécharger',
  search: 'Rechercher',
  filter: 'Filtrer',
  reset: 'Réinitialiser',
  
  // Common terms
  date: 'Date',
  time: 'Heure',
  description: 'Description',
  cost: 'Coût',
  location: 'Emplacement',
  provider: 'Fournisseur',
  technician: 'Technicien',
  customer: 'Client',
  phone: 'Téléphone',
  email: 'Email',
  address: 'Adresse',
  
  // Maintenance
  maintenanceType: 'Type de maintenance',
  maintenanceScheduled: 'Programmée',
  maintenanceRepair: 'Réparation',
  maintenanceInspection: 'Inspection',
  maintenanceUrgent: 'Urgente',
  maintenanceRevision: 'Révision',
  maintenanceIntervention: 'Intervention',
  
  // Parking
  parkingSpot: 'Place de parking',
  parkingAvailable: 'Disponible',
  parkingOccupied: 'Occupée',
  parkingRegular: 'Standard',
  parkingMaintenance: 'Maintenance',
  parkingWashing: 'Lavage',
  parkingPremium: 'Premium',
  
  // Equipment
  equipmentName: 'Nom de l\'équipement',
  equipmentCategory: 'Catégorie',
  quantityAvailable: 'Quantité disponible',
  quantityTotal: 'Quantité totale',
  minimumStock: 'Stock minimum',
  supplier: 'Fournisseur',
  unitCost: 'Coût unitaire',
  
  // Alerts
  alertMaintenanceDue: 'Maintenance due',
  alertInsuranceExpiry: 'Expiration assurance',
  alertRegistrationExpiry: 'Date de 1ère immatriculation',
  alertLowStock: 'Stock faible',
  alertVehicleOverdue: 'Véhicule en retard',
  alertRevisionDue: 'Révision due',
  alertInterventionNeeded: 'Intervention nécessaire',
  
  // Priority levels
  priorityLow: 'Faible',
  priorityMedium: 'Moyenne',
  priorityHigh: 'Élevée',
  priorityCritical: 'Critique',
  
  // Communication
  subject: 'Sujet',
  message: 'Message',
  sender: 'Expéditeur',
  recipient: 'Destinataire',
  department: 'Département',
  admin: 'Administration',
  client: 'Client',
  
  // User roles
  roleAdmin: 'Administrateur',
  roleClient: 'Client',
  
  // Dashboard
  totalVehicles: 'Total véhicules',
  availableVehicles: 'Véhicules disponibles',
  vehiclesInMaintenance: 'Véhicules en maintenance',
  pendingAlerts: 'Alertes en attente',
  upcomingMaintenance: 'Maintenance à venir',
  
  // Forms
  required: 'Requis',
  optional: 'Optionnel',
  selectOption: 'Sélectionner une option',
  selectFile: 'Sélectionner un fichier',
  noFileSelected: 'Aucun fichier sélectionné',
  
  // Messages
  success: 'Succès',
  error: 'Erreur',
  warning: 'Attention',
  info: 'Information',
  loading: 'Chargement...',
  noData: 'Aucune donnée',
  
  // Validation messages
  emailRequired: 'Email requis',
  emailInvalid: 'Email invalide',
  passwordRequired: 'Mot de passe requis',
  passwordTooShort: 'Mot de passe trop court',
  fieldRequired: 'Ce champ est requis',
  invalidDate: 'Date invalide',
  invalidNumber: 'Nombre invalide',
};

export const STATUS_OPTIONS = [
  { value: 'ready', label: FRENCH_LABELS.statusReady },
  { value: 'under_maintenance', label: FRENCH_LABELS.statusUnderMaintenance },
  { value: 'washing', label: FRENCH_LABELS.statusWashing },
  { value: 'out', label: FRENCH_LABELS.statusOut },
  { value: 'returned', label: FRENCH_LABELS.statusReturned },
];

export const MAINTENANCE_TYPE_OPTIONS = [
  { value: 'scheduled', label: FRENCH_LABELS.maintenanceScheduled },
  { value: 'repair', label: FRENCH_LABELS.maintenanceRepair },
  { value: 'inspection', label: FRENCH_LABELS.maintenanceInspection },
  { value: 'urgent', label: FRENCH_LABELS.maintenanceUrgent },
  { value: 'revision', label: FRENCH_LABELS.maintenanceRevision },
  { value: 'intervention', label: FRENCH_LABELS.maintenanceIntervention },
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: FRENCH_LABELS.priorityLow },
  { value: 'medium', label: FRENCH_LABELS.priorityMedium },
  { value: 'high', label: FRENCH_LABELS.priorityHigh },
  { value: 'critical', label: FRENCH_LABELS.priorityCritical },
];

export const PARKING_TYPE_OPTIONS = [
  { value: 'regular', label: FRENCH_LABELS.parkingRegular },
  { value: 'maintenance', label: FRENCH_LABELS.parkingMaintenance },
  { value: 'washing', label: FRENCH_LABELS.parkingWashing },
  { value: 'premium', label: FRENCH_LABELS.parkingPremium },
];

export const DEPARTMENT_OPTIONS = [
  { value: 'admin', label: FRENCH_LABELS.admin },
  { value: 'client', label: FRENCH_LABELS.client },
]; 